import { ca } from '@cian/analytics';

interface IPage {
  dealType?: string | null;
  objectType?: string | null;
  offerID?: number;
  offerPhone?: string;
  pageType?: string;
  siteType?: string;
  extra: {
    filter_rating: number[];
    rating: number | null;
    filter_tag?: string;
  };
}

export function tracFilterAnalyticClick({ page }: { page: IPage }) {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'NewbuildingReviews',
    label: 'Filter',
    name: 'oldevent',
    useLastProducts: true,
    page: page as unknown as Record<string, unknown>,
  });
}
